import { z } from 'zod';

import { createRESTContract } from '../../index';

export const statusContract = createRESTContract({
  getStatus: {
    method: 'GET',
    path: '/status',
    auth: false,
    response: z.void(),
  },
  getVersion: {
    method: 'GET',
    path: '/version',
    auth: false,
    response: z.object({
      version: z.string(),
    }),
  },
});
